<template>
  <div class="pg-medical-templateAdd">
    <PgDrawerSearchTable
      @mouseover.native="onMouseOverDrawer"
      ref="pgDrawerSearchTableRef"
      title="通过模板添加商品"
      :criteriaSearch="false"
      :inputSearch="true"
      idPrefix="flashTemplateAdd"
      :isIconSelection="true"
      :size="drawerSize"
      :column="tableColumn"
      :dataUrl="tableDataUrl"
      :dataParameters="tableParams"
      :columnTableCode="tableColumnTableCode"
      :columnUrl="tableColumnUrl"
      :inputSearchKey="inputSearchKey"
      :inputSearchPlaceholder="inputSearchPlaceholder"
      :visible="visibleSelf"
      @close="close"
      :checkboxBefore="checkboxBefore"
    ></PgDrawerSearchTable>
    <!-- 点击表格添加是，需要给出一个选项 -->
    <div
      class="templateAdd_popover"
      v-if="checkBeforeOption"
      :style="{ left: `${eventX}px`, top: `${eventY}px`, 'z-index': drawerZIndex }"
      @mouseleave="onMouseLeavePopover"
    >
      <p @click="setSelectData('goods')">仅带出商品</p>
      <p @click="setSelectData('number')">带出商品和数量</p>
    </div>
  </div>
</template>
<script setup>
// vue
import { ref } from 'vue'
//hook
import { useFlashAddMedical } from '../hook/use-flash-add'
defineProps({
  // 表格-获取数据的接口
  tableDataUrl: {
    type: String,
    default: '',
  },
  // 表格-外部补充条件
  tableParams: Object,
  drawerSize: {
    type: [String, Number],
    default: 800,
  },
  // 表格-code
  tableColumnTableCode: String,
  // 表格-列定义url
  tableColumnUrl: {
    type: String,
    default: 'rest/ezcomp/dict/table/fetch/',
  },
  // 表格-列定义
  tableColumn: [Array, Object],
  inputSearchKey: String,
  inputSearchPlaceholder: String,
})

// -----------------------------hook-------------------------------
const emit = defineEmits([])

// 获取公共方法
const { emitData } = useFlashAddMedical(emit)

// 添加商品前的选项
const checkBeforeOption = ref(false)
// 当前需要添加的商品
const currentSelectedRow = ref([])

// 点击表格后，弹出选项checkBeforeOption，的定位
const eventX = ref(0)
const eventY = ref(0)

const drawerZIndex = ref(500)
const pgDrawerSearchTableRef = ref(null)

// 表格-选中icon/checkbox后拦截
const checkboxBefore = ({ row, checked }) => {
  return new Promise((resolve) => {
    // 获取当前点击的位置
    if (window.event.currentTarget.className.indexOf('el-checkbox') > -1) {
      if (checked === true) currentSelectedRow.value = [row]
      //   X 需要减去 templateAdd_popover 元素宽度的一半  -再减去 checkbox 宽度的一半，
      eventX.value = window.event.currentTarget.getBoundingClientRect().left - 52 - 7
      // Y 需要加上icon高度的一半 再给他来点间距 就2px吧
      eventY.value = window.event.currentTarget.getBoundingClientRect().top + 10 + 2
      // zIndex 取侧滑的zindex 再加1
      drawerZIndex.value = Number(pgDrawerSearchTableRef.value.$el.style.zIndex) + 1
      checkBeforeOption.value = true
    }
    resolve({
      err: '拦截',
    })
  })
}

const setSelectData = (type) => {
  checkBeforeOption.value = false
  const param = {
    data: currentSelectedRow.value,
  }

  type === 'number'
    ? (param['template_with_amount'] = true)
    : (param['template_with_amount'] = false)

  emitData(param)
}

const onMouseLeavePopover = () => {
  setTimeout(() => {
    checkBeforeOption.value = false
  }, 500)
}

const onMouseOverDrawer = () => {
  if (!checkBeforeOption.value) return false
  setTimeout(() => {
    if (checkBeforeOption.value) checkBeforeOption.value = false
  }, 3000)
}

// -------------------------------侧滑-------------------------------------

const visibleSelf = ref(false)

const open = () => {
  visibleSelf.value = true
}

const close = () => {
  // 关闭时重置
  checkBeforeOption.value = false
  visibleSelf.value = false
}

// ------------------------其他------------------------------------------------
defineExpose({
  open,
  close,
})
</script>
<style lang="scss">
@import '../style/drawer-template-add.scss';
</style>
